import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as model from "../../../models";

@Component({
	selector: 'ticket-print-presentation',
	templateUrl: "./ticket-print.presentation.html",
	styles: [require("./ticket-print.presentation.scss"), require("../ticket-design.presentation.scss")]
})

export class TicketDesingPresentation {
	@Input() previewDataUrl: string
	@Input() ticketDesignFileName: string

	@Input() ticketDesignAssigned: boolean;
	@Input() ticketDesignExists: boolean;

	@Input() hideContent: boolean

	@Input() allowDeletion: boolean = true;

	@Output() addTicketDesignChange = new EventEmitter<File>();
	@Output() deleteTicketDesignClick = new EventEmitter<string>();
	@Output() deleteTicketDesignAssociationClick = new EventEmitter<string>();
	@Output() saveTicketDesignAssociationClick = new EventEmitter<void>();
	@Output() downloadTicketDesignClick = new EventEmitter<void>();

	private forceDeleteTicketDesignAssociation: boolean = false

	public addTicketDesign(file: File) {
		this.addTicketDesignChange.emit(file)
		this.ticketDesignFileName = file.name

	}

	public deleteTicketDesign() {
		this.deleteTicketDesignClick.emit()
	}

	public deleteTicketDesignAssociation() {
		this.forceDeleteTicketDesignAssociation = false
		this.deleteTicketDesignAssociationClick.emit()
	}

}




// WEBPACK FOOTER //
// ./src/app/ui-helper/ticket-design-presentation/ticket-print/ticket-print.presentation.ts